import { zipCode } from 'constants/api-urls';
import { dispatchError } from 'reducers/helpers';
import modalActions from 'reducers/modules/modal/actions';
import cartActions from 'reducers/modules/cart/actions';
import { SET_IS_FETCHING_REGION, SET_REGION } from 'reducers/actions-types';
import axios from 'axios';

/**
 * Set the user zip code retrieving the region string
 * @param { string } zip
 * @return {function: Promise<IRegion>}
 */
export function setRegion({ zip }) {
    return function(dispatch, getState) {
        const url = zipCode(zip);
        dispatch({ type: SET_IS_FETCHING_REGION, isFetching: true });

        return axios.get(url)
            .then(
                /**
                 * @param {IRegion} data
                 * @return {IRegion}
                 */
                ({ data }) => {
                    dispatch({ type: SET_IS_FETCHING_REGION, isFetching: false });
                    dispatch({ type: SET_REGION, region: data });
                    if (data.enabled) {
                        dispatch(modalActions.close());
                    }

                    const { tempItem } = getState().cart;

                    if (tempItem) {
                        dispatch(cartActions.addProduct({ product: tempItem }));
                    }

                    return data;
                })
            .catch(e => {
                dispatchError(dispatch, e, {
                    url,
                    description: e.message,
                });

                dispatch({ type: SET_IS_FETCHING_REGION, isFetching: false });
            });
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/region/helpers.js